import React from 'react';
import C from '../../constants/colors';

export default function StatBadge({ label, value, color = C.blue, onClick, clickable = false, icon: Icon }) {
  return (
    <div
      className={`stat-badge${clickable ? ' clickable' : ''}`}
      onClick={clickable ? onClick : undefined}
      style={{
        background: C.surfaceElevated, border: `1px solid ${C.border}`,
        borderRadius: '10px', padding: '12px 14px',
        cursor: clickable ? 'pointer' : 'default', flex: 1, minWidth: '90px',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '6px' }}>
        {Icon && <Icon size={12} color={color} />}
        <span style={{ fontSize: '11px', color: C.textMuted, fontWeight: 500, letterSpacing: '0.02em' }}>
          {label}
        </span>
      </div>
      <div style={{ fontSize: '22px', fontWeight: 700, color, lineHeight: 1 }}>
        {value}
      </div>
    </div>
  );
}
